import { Box, CircularProgress, Stack, Typography } from "@mui/material";

/** For requests without a predictable content layout; content pages use skeletons. */
export default function LoadingState({
  label = "Loading",
  fullPage = false,
}: {
  label?: string;
  fullPage?: boolean;
}) {
  return (
    <Box
      role="status"
      aria-live="polite"
      aria-busy="true"
      sx={{
        minHeight: fullPage ? "100dvh" : 240,
        display: "grid",
        placeItems: "center",
        p: 3,
        bgcolor: "background.default",
      }}
    >
      <Stack alignItems="center" spacing={2}>
        <CircularProgress size={24} thickness={4} aria-hidden="true" />
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      </Stack>
    </Box>
  );
}
